import { ref as i, onMounted as S, onUnmounted as k } from "vue";
import { throttle as z } from "lodash-es";
import { gsap as c } from "gsap";
import { ScrollTrigger as f } from "./td-longtail-vue-components240.js";
function q(g = 0) {
  c.registerPlugin(f);
  const s = i(null), n = i([]), o = i([]), a = i([]);
  S(() => {
    T(), v(document.querySelector("body"));
  }), k(() => {
    O(), n.value.forEach((e) => {
      s.value && s.value.unobserve(e);
    });
  });
  const T = () => {
    if (s.value) return;
    const e = z(() => {
      g ? setTimeout(() => {
        h();
      }, g) : h();
    }, 700);
    typeof ResizeObserver == "function" && (s.value = new ResizeObserver(e));
  }, v = (e) => {
    !e || n.value.includes(e) || !s.value || (s.value.observe(e), n.value.push(e));
  }, d = (e) => {
    const r = c.timeline(e);
    return o.value.push(r), t(e.scrollTrigger), r;
  }, p = (e, r) => {
    const l = c.from(e, r);
    return o.value.push(l), t(r.scrollTrigger), l;
  }, m = (e, r) => {
    const l = c.to(e, r);
    return o.value.push(l), t(r.scrollTrigger), l;
  }, b = (e) => {
    const r = f.create(e);
    return o.value.push(r), t(e.scroller), r;
  }, t = (e) => {
    if (!M(e)) return;
    const r = typeof e.scroller == "string" ? document.querySelector(e.scroller) : e.scroller;
    v(r);
  }, u = (e) => e instanceof f, M = (e) => e ? e.scroller !== void 0 : !1, O = () => {
    o.value.forEach((e) => {
      e && u(e) ? e.kill(!0) : u(e?.scrollTrigger) && e.scrollTrigger.kill(!0);
    }), o.value = [], a.value.forEach((e) => {
      e?.kill();
    }), a.value = [];
  }, h = () => {
    o.value.forEach((e) => {
      e && u(e) ? e.refresh() : u(e?.scrollTrigger) && e.scrollTrigger.refresh();
    });
  };
  return {
    createTimeline: d,
    createTweenFrom: p,
    createTweenTo: m,
    createScrollTrigger: b,
    createMatchMedia: (e) => {
      const r = c.matchMedia();
      return e && Object.keys(e).forEach((l) => {
        r.add(l, e[l]);
      }), a.value.push(r), r;
    }
  };
}
export {
  q as default
};
